
import { defineComponent, computed, reactive } from 'vue'
import { useStore } from 'vuex'
import TheMyCollectionItemListView from './TheMyCollectionItemListView.vue'
import TheMyCollectionLeftColumn from '@/components/organisms/TheMyCollectionLeftColumn.vue'
import AppButton from '@/components/atoms/AppButton.vue'
import AppSelect from '../atoms/AppSelect.vue'
import KeywordSearch from '../molecules/KeywordSearch.vue'
import { useI18n } from 'vue-i18n'
import { displayModeList } from '@/data/selector/displayModeList'
import { displayContentsList } from '@/data/selector/displayContentsList'
import { mycollectionSortList } from '@/data/selector/mycollectionSortList'
import { getSelector } from '@/data/selector/getSelector'
import toLocale from '@/helpers/util/toLocale'
import ModalSheetMobile from '@/components/organisms/ModalSheetMobile.vue'
import CloserController from '../molecules/CloserController.vue'
import RadioButtonList from '../molecules/RadioButtonList.vue'

export default defineComponent({
  components: {
    TheMyCollectionItemListView,
    TheMyCollectionLeftColumn,
    AppButton,
    AppSelect,
    KeywordSearch,
    ModalSheetMobile,
    CloserController,
    RadioButtonList,
  },
  props: {},
  setup (props, context) {
    const store = useStore()
    const i18n = useI18n()
    const lang = i18n.locale

    const VIEW_TYPE_LIST_ITEM = 'list'
    const VIEW_TYPE_THUMBNAIL = 'thumbnail'

    const SORT_SCORE = 'SCORE' // 適合度順
    // 参照表
    // const SORT_TITLE_ASC = 'TITLE_ASC' // タイトル：昇順
    // const SORT_TITLE_DESC = 'TITLE_DESC' // タイトル：降順
    // const SORT_CREATOR_ASC = 'PUBLISHER_ASC' // 著者：昇順
    // const SORT_CREATOR_DESC = 'PUBLISHER_DESC' // 著者：降順
    // const SORT_ISSUED_ASC = 'COLLECTION_ASC' // 出版日：新しい順
    // const SORT_ISSUED_DESC = 'COLLECTION_DESC' // 出版日：古い順
    // const SORT_CALL_NUMBER_ASC = 'BILL_NUMBER_ASC' // 請求記号：昇順
    // const SORT_CALL_NUMBER_DESC = 'BILL_NUMBER_DESC' // 請求記号：降順

    // TODO refactor ページネーション対応時にsearchResultState.tsへ色々移管する
    const state = reactive({
      keyword: '',
      displayedItemViewPattern: true,
      displayMode: VIEW_TYPE_LIST_ITEM,
      sort: SORT_SCORE,
      showModal: false,
      showSortList: true,
    })

    const isServer = typeof window === 'undefined'

    // アイテム表示スタイル選択
    const displayModeLocale = computed(() => getSelector('displayModeList', displayModeList, i18n.t))

    // コンテンツ表示／非表示
    const displayItemViewPatternList = computed(() => getSelector('displayContentsList', displayContentsList, i18n.t))
    const sortList = computed(() => getSelector('mycollectionSortList', mycollectionSortList, i18n.t))

    const tagName = computed(() => store.getters.myCollectionSelectedTagName)
    const keyword = computed({
      get: () => store.getters.myCollectionKeyword,
      // MY_COLLECTION_KEY_WORD
      set: (val) => {
        store.commit('MY_COLLECTION_KEY_WORD', val)
      }
    })

    const sort = computed({
      get: () => store.getters.myCollectionSort,
      set: (val) => {
        store.dispatch('myCollectionSelectDisplayMode', val)
        state.showModal = false
      }
    })

    const hasError = computed(() => {
      // return store.getters.hasErrorInSearchResultPage
      return false
    })
    const errorMessage = computed(() => {
      // return store.getters.errorTextInSearchResultPage
      return false
    })

    // state.displayModeによってマイコレクション表示用Objectを出しわけする
    const myCollections = computed(() => {
      const item: string = VIEW_TYPE_LIST_ITEM
      const thumbnail: string = VIEW_TYPE_THUMBNAIL

      return {
        [item]: store.getters.myCollectionList,
        [thumbnail]: store.getters.myCollectionThumbnail
      }[state.displayMode]
    })
    const myCollectionItemCount = computed(() => store.getters.myCollectionItemCount)

    const removeList = computed(() => {
      const list = store.state.myCollectionInfo.removeList
      return list
    })

    const isDisplayItem = (item: any) => {
      if (state.displayMode === VIEW_TYPE_LIST_ITEM) return true
      if (state.displayedItemViewPattern) return true

      return item.isItem || false
    }

    const tagSelected = () => { state.showModal = false }

    const showModal = () => {
      context.emit('showModal')
      state.showModal = true
      if (!isServer) {
        const focusElement = document.getElementById('modal-focus-target')
        if (focusElement) {
          focusElement.focus()
        }
      }
    }

    return {
      VIEW_TYPE_LIST_ITEM,
      VIEW_TYPE_THUMBNAIL,
      keyword,
      myCollections,
      myCollectionItemCount,
      state,
      tagName,
      displayModeLocale,
      displayItemViewPatternList,
      removeList,
      sortList,
      sort,
      hasError,
      errorMessage,
      isDisplayItem,
      toLocale,
      lang,
      tagSelected,
      showModal,
    }
  }
})
